const SortIcon = ({ sort }) => {
  // Unsorted
  if (sort === false || sort == null) {
    return (
      <span className="flex flex-col text-gray-300 leading-none">
        <svg
          width="10"
          height="10"
          viewBox="0 0 20 20"
          fill="none"
          className="w-3 h-3"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 12l4-4 4 4"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <svg
          width="10"
          height="10"
          viewBox="0 0 20 20"
          fill="none"
          className="w-3 h-3 -mt-1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 8l4 4 4-4"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    );
  }

  // Ascending
  if (sort === "asc") {
    return (
      <svg
        width="10"
        height="10"
        viewBox="0 0 20 20"
        fill="none"
        className="w-3 h-3 text-blue-500"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 12l4-4 4 4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  // Descending
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 20 20"
      fill="none"
      className="w-3 h-3 text-blue-500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8l4 4 4-4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SortIcon;
